import Hero from "../components/Hero";
import Work from "../components/Work";
import Experience from "../components/Experience";
import About from "../components/About";
import Capabilities from "../components/Capabilities";
import Certificates from "../components/Certificates";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

function Firstpage() {
  return (
    <>
      <Hero />
      <Work />
      <Experience />
      <About />
      <Capabilities />
      <Certificates />
      <Contact />
      <Footer />
    </>
  );
}

export default Firstpage;
